<div *ngIf="!!storyboards?.length">
    <h3 class="text-light font-weight-bold m-1 pb-2">STORYBOARDS</h3>
    <div class="container-fluid dashboard clearfix">
        <div class="row">
          <div class="py-1 px-2 col-sm-6" *ngFor="let item of storyboards; let i = index">
              <app-storyboard-item [storyboard]="item"></app-storyboard-item>
          </div>
        </div>
    </div>
</div>
